/* eslint-disable no-await-in-loop */

import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import { GetVimsSFTPReport } from './types';
import { VimsSFTPReportResponseBody } from '../entities/vims-sftp-report/vims-sftp-report-response-body';
import { enqueueSnackbarAction } from '../store/snackbar/actions';
import { vimsSFTPActionNames } from '../store/vims-sftp-files/types';
import { axiosInstance } from "../axios-instance";

class VimsSFTPFileReport {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  private storageV1BaseUrl?: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string, storageV1BaseUrl?: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
    this.storageV1BaseUrl = storageV1BaseUrl;
  }

  exportVimsSFTPReportStorageApi = (input: string, dispatch: any) => {
    const accessToken = localStorage.getItem('accessToken');
    const url = `${this.storageV1BaseUrl}/export/files/${input}/metadata`;
    return axiosInstance.get(`${url}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.data.status === 'uploaded') {
          window.location = response.data?.downloadUrl;
          if (!response) {
            dispatch({ type: vimsSFTPActionNames.SET_IS_LOADING, payload: false });
            dispatch(
              enqueueSnackbarAction({
                message: 'Vims SFTP Report CSV export failed',
                options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
              }),
            );
          } else {
            dispatch({
              type: vimsSFTPActionNames.SET_VIMS_SFTP_FILE_ID,
              payload: response.data,
            });

            dispatch(
              enqueueSnackbarAction({
                message: 'Vims SFTP Report CSV exported successfully',
                options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
              }),
            );
            dispatch({ type: vimsSFTPActionNames.SET_IS_LOADING, payload: false });
            return response.data?.downloadUrl;
          }
        } else if (response.data.status === 'uploadFailed') {
          dispatch({ type: vimsSFTPActionNames.SET_IS_LOADING, payload: false });
          dispatch(
            enqueueSnackbarAction({
              message: 'Vims SFTP Report CSV export failed',
              options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
            }),
          );
          return 'Fail';
        }
        return '';
      })
      .catch((error) => {
        throw new Error(error);
      });
  };

  exportVimsSFTPReportFile(
    input: GetVimsSFTPReport,
    dispatch: any,
  ): Promise<AxiosResponse<VimsSFTPReportResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<VimsSFTPReportResponseBody>(`${this.baseUrl}/generateReport`, undefined, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => this.fetchRetry(response?.data?.fileId, 10, dispatch))
      .catch((error) => {
        dispatch({ type: vimsSFTPActionNames.SET_IS_LOADING, payload: false });
        const errorMessage = error.response.data.errors?.generateReportParams;
        dispatch(
          enqueueSnackbarAction({
            message: `Export Failed - ${errorMessage}` || 'Vims SFTP Report CSV export failed',
            options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
          }),
        );
      });
  }

  fetchRetry = async (input: string, n: number, dispatch: any) => {
    let error;
    try {
      const isUrlGenerated = await this.exportVimsSFTPReportStorageApi(input, dispatch);
      if (isUrlGenerated === '' && n - 1 !== 0) {
        await new Promise(() => setTimeout(() => this.fetchRetry(input, n - 1, dispatch), 15000));
      } else {
        clearTimeout();
        return isUrlGenerated;
      }
    } catch (error_) {
      error = error_;
    }
    return error;
  };
}

export default VimsSFTPFileReport;
